import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';
import { Observable, startWith, map } from 'rxjs';
import { CommonModule } from '@angular/common';
import { Output, EventEmitter, Input } from '@angular/core';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
@Component({
  selector: 'app-view-mode-project-type',
  templateUrl: './view-mode-project-type.component.html',
  styleUrls: ['./view-mode-project-type.component.css'],
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule,MatFormFieldModule,MatInputModule],
})
export class ViewModeProjectTypeComponent implements OnInit, OnChanges {
  @Input() projectType: any;
  @Input() projectSubType: any;
  @Input() projectTypeId: any;
  selectedType: any;
  customType: any;
  customParent: any;

  projectTypeControl = new FormControl('');
  projectSubTypeControl = new FormControl('');
  parants: any = [];
  childs: any = [];

  filteredStakeholders!: Observable<string[]>;
  filteredParents!: Observable<any[]>;

  showDropdownMainProjectType = false;
  showDropdownSubProjectType = false;
  customParantShowDropdown = false;

  updatedProjectTypeId: any;
  updatedProjectSubTypeId: any;
  updatedCustomProjectType: any;

  @Output() onCLose: EventEmitter<any> = new EventEmitter<any>();
  @Output() onSave: EventEmitter<any> = new EventEmitter<any>();
  form: FormGroup;
  constructor(
    private projectsService: ProjectsService,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      customType: [''],
    });
    this.form.get('customType')?.valueChanges.subscribe((value) => {
      this.customType = value;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['projectTypeId']) {
      console.log('this.projectTypeId', this.projectTypeId);
      this.getProjectSubTypes(this.projectTypeId);
      this.projectTypeControl.setValue(this.projectType);
    }

    if (changes['projectSubType']) {
      console.log('this.projectSubType', this.projectSubType);
      // Update the FormControl value when projectSubType changes
      this.projectSubTypeControl.setValue(this.projectSubType);
    }
  }

  ngOnInit() {
    console.log('Project Type Id: ', this.projectTypeId);

    this.getProjectTypes();
    this.getProjectSubTypes(this.projectTypeId);
    // Set up filtered observable based on the control value
    this.filteredParents = this.projectTypeControl.valueChanges.pipe(
      startWith(''),
      map((value) => this.filterProjectTypes(value || '')) // Pass the input value to filter function
    );
  }

  updateCustomType(value: string) {
    this.form.get('customType')?.setValue(value);
  }

  private filterProjectTypes(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.parants?.filter((parant: any) =>
      parant?.name?.toLowerCase()?.includes(filterValue)
    );
  }
  getProjectTypes() {
    this.projectsService.getAllProjectTypes().subscribe({
      next: (response: any) => {
        console.log('Project Types => ', response.data);
        this.parants.push(response.data);
        this.parants[0].push({ name: 'Custom', id: 'custom' });
      },
      error: (error: any) => {
        console.error('Error fetching the project types:', error);
      },
    });
  }
  getProjectSubTypes(id: any) {
    console.log('projectTypeId', id);
    if (id === undefined) return;
    this.projectsService.getAllProjectSubTypes(id).subscribe({
      next: (response: any) => {
        console.log('The child is:', response.data);
        this.childs.push(response.data);
      },
      error: (error: any) => {
        console.error('Error fetching the project types:', error);
      },
    });
  }

  filterUniqueParents(data: any[]): any[] {
    const uniqueParents = new Map<number, any>();

    // Loop through data
    data.forEach((item) => {
      if (item.parent_id === null) {
        // Check if it's a top-level parent (parent_id is null)
        if (!uniqueParents.has(item.id)) {
          uniqueParents.set(item.id, item);
        }
      } else if (item.parent) {
        // Check if its parent is already in the uniqueParents map
        if (!uniqueParents.has(item.parent.id)) {
          uniqueParents.set(item.parent.id, item.parent);
        }
      }
    });

    // Convert the map values to an array and return
    return Array.from(uniqueParents.values());
  }

  onSelectionMainProjectType(option: any, id: any) {
    // this.changeProjectType.emit(id); // Emit the name of the selected project type
    this.updatedProjectTypeId = id;
    this.projectType = option; // Store the selected project type
    this.selectedType = option;
    this.showDropdownMainProjectType = false;
    this.childs = [];
    if (id !== 'custom') {
      this.getProjectSubTypes(id);
    } else {
      this.projectTypeControl.setValue('');
    }
    this.projectSubTypeControl.setValue('');
  }
  onSelectionCustomParent(option: any, id: any) {
    if (id !== 'custom') {
      this.updatedCustomProjectType = id;
    }
    this.customParent = option; // Store the selected project type
    // this.selectedType = option;
    this.customParantShowDropdown = false;
    this.childs = [];
    // this.getProjectSubTypes(id);
  }

  onSelectionSubProjectType(option: string, id: any) {
    // this.changeProjectSubType.emit(id);
    this.updatedProjectSubTypeId = id;
    this.projectSubType = option;
    this.showDropdownSubProjectType = false; // Hide dropdown after selection
  }

  onFocusMainProjectType() {
    this.showDropdownMainProjectType = true; // Show the dropdown when input is focused
  }
  onFocusDropdownSubProjectType() {
    this.showDropdownSubProjectType = true; // Show the dropdown when input is focused
  }

  onBlurMainProjectType() {
    // Hide the dropdown when input is blurred (optional)
    setTimeout(() => {
      this.showDropdownMainProjectType = false;
    }, 200);
  }
  onBlurDropdownSubProjectType() {
    // Hide the dropdown when input is blurred (optional)
    setTimeout(() => {
      this.showDropdownSubProjectType = false;
    }, 200);
  }

  onBlurCustomParent() {
    // Hide the dropdown when input is blurred (optional)
    setTimeout(() => {
      this.customParantShowDropdown = false;
    }, 200);
  }
  onFocusCustomParent() {
    this.customParantShowDropdown = true; // Show the dropdown when input is focused
  }

  save() {
    // const newValue = this.form.get('name')?.value;
    // console.log('Saved value:', newValue);
    this.onSave.emit({
      updatedProjectTypeId: this.updatedProjectTypeId,
      updatedProjectSubTypeId: this.updatedProjectSubTypeId,
      customParant: this.customParent,
      updatedCustomParantId: this.updatedCustomProjectType,
      updatedCustomProjectType: this.customType,
    });
  }

  cancel() {
    this.onCLose.emit();
  }
}
